<template>
  <div class="container mt-4">
    <h2 class="mb-4 text-primary">Teacher Login Info</h2>

    <div v-if="teacher && teacher.length > 0">
      <table class="table table-bordered table-hover">
        <thead class="table-dark">
          <tr>
            <th>#</th>
            <th>User ID</th>
            <th>Login Time</th>
            <th>Latitude</th>
            <th>Longitude</th>
            <th>Accuracy</th>
            <th>IP Address</th>
            <th>Device</th>
            <th>Browser</th>
            <th>Created At</th>
            <th>Location</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(log, index) in teacher" :key="log.id">
            <td>{{ index + 1 }}</td>
            <td>{{ log.user_id }}</td>
            <td>{{ formatDate(log.login_time) }}</td>
            <td>{{ log.latitude }}</td>
            <td>{{ log.longitude }}</td>
            <td>{{ log.accuracy }}</td>
            <td>{{ log.ip_address }}</td>
            <td>{{ log.device }}</td>
            <td>{{ log.browser }}</td>
            <td>{{ formatDate(log.created_at) }}</td>
            <td>
                <button
                type="button"
                class="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#viewMapLocationModal"
                @click="showMap(log)">
                View
            </button>

            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else>
      <p class="alert alert-info">No login logs found for this institute.</p>
    </div>








<!-- Modal -->
<div class="modal fade" id="viewMapLocationModal" tabindex="-1" aria-labelledby="viewMapLocationModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="viewMapLocationModalLabel">Map Location</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div id="map" style="width: 100%; height: 300px;"></div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
      </div>
    </div>
  </div>
</div>



  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    teacherId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      teacher: null,
      selectedLocation: {
        latitude: null,
        longitude: null,
        accuracy: null
      }
    };
  },
  mounted() {
    this.fetchTeacherLoginInfo();
  },
  methods: {
    async fetchTeacherLoginInfo() {
      try {
        const response = await axios.get('/teacher-login-info', {
          headers: {
            'Teacher-ID': this.teacherId
          }
        });

        this.teacher = response.data.data;
      } catch (error) {
        console.error('Error fetching login info:', error);
      }
    },
    formatDate(dateStr) {
      const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
      return new Date(dateStr).toLocaleString(undefined, options);
    },
 showMap(log) {
  this.selectedLocation.latitude = log.latitude;
  this.selectedLocation.longitude = log.longitude;
  this.selectedLocation.accuracy = log.accuracy;

  this.$nextTick(() => {
    const mapDiv = document.getElementById('map');
    if (mapDiv && log.latitude && log.longitude) {
      const mapsSrc = `https://www.google.com/maps?q=${log.latitude},${log.longitude}&hl=en&z=15&output=embed`;
      mapDiv.innerHTML = `
        <iframe
          width="100%"
          height="300"
          frameborder="0"
          style="border:0"
          src="${mapsSrc}"
          allowfullscreen=""
          aria-hidden="false"
          tabindex="0">
        </iframe>
        <p class="mt-2"><strong>Location Accuracy:</strong> ±${Math.round(log.accuracy)} meters</p>
      `;
    }
  });
}


  }
};
</script>

